import React, { useState, useEffect } from "react";

function ChoiceButtonsComponent(props) {
    const [selectedValue, setSelectedValue] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);

    const handleClick = (val) => {

        if (props.multiple) {

            if (selectedItems.includes(val)) {
                let items = selectedItems.filter(item => item != val);
                setSelectedItems(items);

                props.handleInput({
                    target: {
                        id: props.id,
                        value: items,
                    }
                });
            } else {

                if (selectedItems) {
                    selectedItems.push(val);
                    setSelectedItems(selectedItems);

                    props.handleInput({
                        target: {
                            id: props.id,
                            value: selectedItems,
                        }
                    });
                }
            }

        } else {
            setSelectedValue(val);
            props.handleInput({
                target: {
                    id: props.id,
                    value: val,
                }
            });
        }
    };

    const isSelected = (val) => {
        if (props.multiple) {
            return selectedItems.includes(val);
        } else {
            return val === selectedValue;
        }
    };

    useEffect(() => {
        setSelectedValue(props.value || 0);
    }, [props.value]);

    return (
        <div className="custom-container">
            {props.label ? (<label className="form-label mb-2">{props.label} </label>) : ""}
            <div className="button-container">
                {props.items && props.items.map((item, index) => (
                    <div className="button-space" key={index}>
                        <button
                            onClick={() => handleClick(item.value)}
                            type="button"
                            disabled={props.disabled}
                            style={{ width: props.width }}
                            className={`btn btn-success ${isSelected(item.value) ? 'custom-service-button-selected' : 'custom-service-button'}`}
                        >
                            {item.text}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ChoiceButtonsComponent;
